import { actionCreator } from '@ardoq/rxbeach';

export const toggleEndDateEnabled = actionCreator(
  '[broadcastSchedulerAndReminderForm] TOGGLE_END_DATE_ENABLED'
);
